/* ===========================================================================
 *  acf_blocks/svg-magic-map   — full file (pan-zoom fixes only)
 * ======================================================================== */
(($) => {
  "use strict";
  console.log("acf_blocks/svg-magic-map scripts loaded…");
  /* ------------------------------------------------------------------ */
  /*  Global config & helpers                                           */
  /* ------------------------------------------------------------------ */
  const data = window.mallMapData || {};
  const config = window.mallMapConfig || {};
  const EXTRA_MOBILE_ZOOM = 1.15;
  const DESKTOP_HORIZONTAL_OFFSET = 100; // Adjust this value: positive = right, negative = left
  const MOBILE_PAN_OFFSET = { x: 20, y: 20 }; // Adjust these values: x = horizontal, y = vertical offset for mobile
  const isMobile =
    /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent) ||
    window.matchMedia("(pointer:coarse)").matches;

  /* Convert screen-coords → SVG-coords (no library helper needed) */
  function svgPoint(svg, clientX, clientY) {
    const pt = svg.createSVGPoint();
    pt.x = clientX;
    pt.y = clientY;
    return pt.matrixTransform(svg.getScreenCTM().inverse());
  }

  /* ------------------------------------------------------------------ */
  /*  Initialise once the inline SVG is measurable                      */
  /* ------------------------------------------------------------------ */
  window.addEventListener("load", () => {
    const wrapper = document.getElementById("map-wrapper2");
    const svgEl = wrapper?.querySelector("svg");
    if (!svgEl) return;
    wrapper.style.touchAction = "none"; // stops the browser from hijacking pinch
    svgEl.style.touchAction = "none";
    /* WordPress sometimes paints late → wait one frame if size = 0 */
    if (!wrapper.offsetWidth || !wrapper.offsetHeight) {
      return requestAnimationFrame(() =>
        window.dispatchEvent(new Event("load"))
      );
    }

    // Function to properly cover and center the SVG (like CSS cover)
    const coverAndCenterMap = (panZoomInstance, horizontalOffset = 0) => {
      if (!panZoomInstance) return;
      
      try {
        // Reset any previous transformations
        panZoomInstance.resetPan();
        panZoomInstance.resetZoom();
        
        // Use contain() for CSS cover-like behavior (fills entire container)
        panZoomInstance.contain();  // This fills the container like CSS cover
        panZoomInstance.center();   // Center the SVG
        
        // Apply horizontal offset if specified (positive = move right, negative = move left)
        if (horizontalOffset !== 0 && !isMobile) {
          const currentPan = panZoomInstance.getPan();
          panZoomInstance.pan({
            x: currentPan.x + horizontalOffset,
            y: currentPan.y
          });
          console.log(`Applied horizontal offset: ${horizontalOffset}px`);
        }
        
        const currentZoom = panZoomInstance.getZoom();
        console.log(`Map set to cover mode with zoom level: ${currentZoom.toFixed(2)}`);
      } catch (error) {
        console.warn("Error covering map:", error);
      }
    };

    /* ---------------- svg-pan-zoom instance ---------------------- */
    const pz = svgPanZoom(svgEl, {
      zoomEnabled: true,
      mouseWheelZoomEnabled: false, // custom handler below
      controlIconsEnabled: false,
      fit: false,     // We'll handle fitting manually for better control
      center: false,  // We'll handle centering manually
      contain: true,  // Enable contain mode for CSS cover-like behavior
      minZoom: 2,   // Very low minimum to allow proper cover scaling
      maxZoom: 12,
      // NEW: hand off every touch event to Hammer
      /* Hand off only pinch (and double-tap) to Hammer;
     svg-pan-zoom handles one-finger drag itself. */
      customEventsHandler: {
        haltEventListeners: [
          "touchstart",
          "touchmove",
          "touchend",
          "touchcancel",
        ],

        init() {
          /* ------------------------------------------------------
           *  Hammer manager: Pan (1-finger), Pinch (2-finger) + Tap
           * ---------------------------------------------------- */
          const ham = new Hammer.Manager(wrapper, { touchAction: "none" });
          const pan = new Hammer.Pan({
            direction: Hammer.DIRECTION_ALL,
            threshold: 0,
          });
          const pinch = new Hammer.Pinch({ threshold: 0, pointers: 2 });
          const tap = new Hammer.Tap({ taps: 2 });

          ham.add([pan, pinch, tap]);
          pinch.recognizeWith([pan, tap]); // gestures can coexist

          /* ------------ single-finger drag (Pan) ------------- */
          let panStart = { x: 0, y: 0 };
          ham.on("panstart", (ev) => {
            panStart = pz.getPan();
            wrapper.classList.add("grabbing");
            // Mark as dragging if starting on a store
            if (ev.target.closest(".store")) {
              isDragging = true;
            }
          });

          ham.on("panmove", (ev) => {
            const z = pz.getSizes().realZoom || 1;
            pz.pan({
              x: panStart.x + ev.deltaX / z,
              y: panStart.y + ev.deltaY / z,
            });
            // Mark as dragging if moving over a store
            if (ev.target.closest(".store")) {
              isDragging = true;
            }
          });

          ham.on("panend", () => {
            wrapper.classList.remove("grabbing");
            // Reset dragging flag after a short delay to allow click events to check it
            setTimeout(() => { isDragging = false; }, 50);
          });

          /* --------------- pinch-to-zoom --------------------- */
          let startZoom = 1;
          ham.on("pinchstart", () => {
            startZoom = pz.getZoom();
            wrapper.classList.add("grabbing");
          });

          ham.on("pinchmove", (ev) => {
            ev.preventDefault(); // stop browser page-zoom
            const newZoom = startZoom * ev.scale;

            /* zoom about the gesture centre */
            const rect = svgEl.getBoundingClientRect();
            const point = {
              x: ev.center.x - rect.left,
              y: ev.center.y - rect.top,
            };
            pz.zoomAtPoint(newZoom, point);
          });

          ham.on("pinchend", () => wrapper.classList.remove("grabbing"));

          /* --------------- double-tap reset ------------------ */
          ham.on("doubletap", (ev) => {
            if (ev.target.closest(".store")) return; // ignore taps on stores
            pz.resetZoom();
            pz.center();
          });

          /* keep a reference so svg-pan-zoom can destroy it */
          this.hammer = ham;
        },

        destroy() {
          this.hammer && this.hammer.destroy();
        },
      },
    });

    /* -----------------------------------------------------------
     *  Custom buttons (top-right, inside the map)
     * --------------------------------------------------------- */
    const controls = document.createElement("div");
    var svgPlus = `<svg id="tmpl-zoom-in" width="28" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.09073 12.1818H11.818M11.818 12.1818H16.5453M11.818 12.1818V16.909M11.818 12.1818V7.4545M11.818 22.8181C5.9437 22.8181 1.18164 18.0561 1.18164 12.1818C1.18164 6.30747 5.9437 1.54541 11.818 1.54541C17.6923 1.54541 22.4544 6.30747 22.4544 12.1818C22.4544 18.0561 17.6923 22.8181 11.818 22.8181Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
    var svgMinus = `<svg  id="tmpl-zoom-out" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.09073 11.8181H16.5453M11.818 22.4545C5.9437 22.4545 1.18164 17.6924 1.18164 11.8181C1.18164 5.94382 5.9437 1.18176 11.818 1.18176C17.6923 1.18176 22.4544 5.94382 22.4544 11.8181C22.4544 17.6924 17.6923 22.4545 11.818 22.4545Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;
    controls.className = "map-zoom-controls";
    controls.innerHTML = `
        <button class="zoom-btn zoom-in"  aria-label="zoom in">
          ${svgPlus}
       </button>
        <button class="zoom-btn zoom-out" aria-label="zoom out">
          ${svgMinus}
        </button>`;
    wrapper.appendChild(controls); // inside #map-wrapper2

    controls
      .querySelector(".zoom-in")
      .addEventListener("click", () => pz.zoomIn());
    controls
      .querySelector(".zoom-out")
      .addEventListener("click", () => pz.zoomOut());

    /* ---------------- Initial cover and center setup -------------- */
    // Initial cover and center - do this after pan-zoom is fully initialized
    setTimeout(() => {
      coverAndCenterMap(pz, DESKTOP_HORIZONTAL_OFFSET);
      
      // Set dynamic min/max zoom based on current zoom level after cover
      const currentZoom = pz.getZoom();
      const sizes = pz.getSizes();
      
      // Calculate the proper cover zoom for this container size
      const scaleX = sizes.width / sizes.viewBox.width;
      const scaleY = sizes.height / sizes.viewBox.height;
      const coverZoom = Math.max(scaleX, scaleY);
      
      console.log("Initial setup debug:", {
        currentZoom,
        coverZoom,
        realZoom: sizes.realZoom,
        width: sizes.width,
        height: sizes.height,
        viewBoxWidth: sizes.viewBox.width,
        viewBoxHeight: sizes.viewBox.height,
        scaleX,
        scaleY
      });
      
      if (Number.isFinite(currentZoom) && currentZoom > 0 && Number.isFinite(coverZoom)) {
        // Use the cover zoom as the minimum (with small buffer)
        const newMinZoom = coverZoom * 0.95; // Allow slight zoom out but not much
        const newMaxZoom = coverZoom * 8;
        
        console.log("Initial zoom limits:", { newMinZoom, newMaxZoom, coverZoom });
        
        // Allow zooming out to fit level (CSS contain behavior) as minimum
        pz.setMinZoom(newMinZoom);
        pz.setMaxZoom(newMaxZoom); // Max zoom relative to cover zoom
        
        // Re-apply cover after setting new zoom limits
        coverAndCenterMap(pz, DESKTOP_HORIZONTAL_OFFSET);
        
        console.log("Initial setup - final zoom limits:", {
          newMinZoom,
          newMaxZoom,
          currentZoom: pz.getZoom()
        });
      }
      
      // Apply mobile extra zoom AFTER cover/contain is established
      if (isMobile && EXTRA_MOBILE_ZOOM > 1) {
        console.log("Applying mobile extra zoom after cover setup");
        const coverZoom = pz.getZoom();
        const mobileZoom = coverZoom * EXTRA_MOBILE_ZOOM;
        
        // Apply the extra mobile zoom from center with pan offset
        pz.zoomAtPoint(
          mobileZoom,
          { x: window.innerWidth / 2, y: window.innerHeight / 2 }
        );
        
        // Apply mobile pan offset after zoom
        const currentPan = pz.getPan();
        pz.pan({
          x: currentPan.x + MOBILE_PAN_OFFSET.x,
          y: currentPan.y + MOBILE_PAN_OFFSET.y
        });
        
        console.log(`Mobile pan offset applied: x=${MOBILE_PAN_OFFSET.x}, y=${MOBILE_PAN_OFFSET.y}`);
        
        // Set minimum zoom for mobile to prevent zooming out past container boundaries
        // Use the cover zoom as the absolute minimum (the zoom level that fills the container)
        const mobileMinZoom = coverZoom; // Allow slight zoom out but not below container coverage
        const mobileMaxZoom = mobileZoom * 4; // Allow zooming in from mobile level
        
        pz.setMinZoom(mobileMinZoom);
        pz.setMaxZoom(mobileMaxZoom);
        
        console.log(`Mobile zoom applied: ${coverZoom.toFixed(2)} → ${mobileZoom.toFixed(2)}`);
        console.log(`Mobile zoom limits set: min=${mobileMinZoom.toFixed(2)}, max=${mobileMaxZoom.toFixed(2)}`);
      } else if (config.initialStore) {
        // Desktop behavior - just focus on initial store
        // focusOn(config.initialStore);
      }
    }, 50);

    /* ---------------- resize handler to re-cover map ------------ */
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        try {
          console.log("Handling window resize - re-covering map");
          
          // Resize the pan-zoom instance to match new container dimensions
          pz.resize();
          
          // Re-cover and center the map in the new container size
          coverAndCenterMap(pz);
          
          // Update zoom limits based on new cover zoom
          const currentZoom = pz.getZoom();
          const sizes = pz.getSizes();
          
          // Calculate the proper cover zoom for this container size
          const scaleX = sizes.width / sizes.viewBox.width;
          const scaleY = sizes.height / sizes.viewBox.height;
          const coverZoom = Math.max(scaleX, scaleY);
          
          console.log("Resize debug:", {
            currentZoom,
            coverZoom,
            realZoom: sizes.realZoom,
            width: sizes.width,
            height: sizes.height,
            viewBoxWidth: sizes.viewBox.width,
            viewBoxHeight: sizes.viewBox.height,
            scaleX,
            scaleY
          });
          
          if (Number.isFinite(currentZoom) && currentZoom > 0 && Number.isFinite(coverZoom)) {
            // Calculate minimum zoom to prevent zooming below container bounds
            const newMinZoom = coverZoom * 0.95; // Allow slight zoom out but not much
            const newMaxZoom = Math.max(currentZoom * 3, coverZoom * 8); // Preserve current zoom range
            
            console.log("Setting new zoom limits:", { newMinZoom, newMaxZoom, coverZoom, currentZoom, isMobile });
            
            pz.setMinZoom(newMinZoom);
            pz.setMaxZoom(newMaxZoom);
            
            // Re-apply cover after setting new zoom limits
            coverAndCenterMap(pz, DESKTOP_HORIZONTAL_OFFSET);
            console.log("Zoom limits updated and map re-covered");
            
            // Verify the limits were actually set
            console.log("Actual zoom limits after setting:", {
              newMinZoom,
              newMaxZoom,
              currentZoom: pz.getZoom()
            });
          }
        } catch (error) {
          console.warn("Error handling resize:", error);
        }
      }, 250); // Debounce resize events
    };
    
    window.addEventListener('resize', handleResize);
    
    // Also handle orientation changes on mobile
    window.addEventListener('orientationchange', () => {
      setTimeout(handleResize, 500); // Longer delay for orientation change
    });

    /* ---------------- edge-lock panning -------------------------- */
    pz.setBeforePan((oldPan, newPan) => {
      const s = pz.getSizes();
      if (!Number.isFinite(s.realZoom)) return oldPan;

      const z = s.realZoom;
      const left = s.width - s.viewBox.width * z;
      const top = s.height - s.viewBox.height * z;
      return {
        x: Math.min(0, Math.max(left, newPan.x)),
        y: Math.min(0, Math.max(top, newPan.y)),
      };
    });

    /* ----------------------------------------------------------------
     *  "Hold Ctrl/⌘ + scroll to zoom" overlay
     * ----------------------------------------------------------------*/
    const hint = document.createElement("div");
    hint.id = "zoomHint";
    hint.innerHTML =
      "Hold <strong>Ctrl</strong> (Windows) or <strong>⌘</strong> (Mac) and scroll to zoom";
    wrapper.appendChild(hint);

    const setHintVisible = (show) => {
      hint.classList.toggle("zoomHint--hide", !show);
    };

    // Track current key state
    let isModifierPressed = false;

    document.addEventListener("keydown", (e) => {
      if (e.ctrlKey || e.metaKey) {
        isModifierPressed = true;
        pz.enableMouseWheelZoom();
        setHintVisible(false); // hide while the key is held
      }
    });

    document.addEventListener("keyup", (e) => {
      if (!e.ctrlKey && !e.metaKey) {
        isModifierPressed = false;
        pz.disableMouseWheelZoom();
        setHintVisible(true);
      }
    });

    // Additional safeguards to ensure mouseWheelZoom is properly disabled
    window.addEventListener("blur", () => {
      // Window lost focus - disable zoom and show hint
      isModifierPressed = false;
      pz.disableMouseWheelZoom();
      setHintVisible(true);
    });

    window.addEventListener("focus", () => {
      // Window regained focus - reset to safe state
      // User will need to press Ctrl/⌘ again to enable zoom
      setTimeout(() => {
        isModifierPressed = false;
        pz.disableMouseWheelZoom();
        setHintVisible(true);
      }, 100);
    });

    // Reset on page visibility change (tab switching)
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        // Tab became visible - reset to safe state
        setTimeout(() => {
          isModifierPressed = false;
          pz.disableMouseWheelZoom();
          setHintVisible(true);
        }, 100);
      }
    });

    // Reset when mouse enters the map area if no modifiers are pressed
    wrapper.addEventListener("mouseenter", () => {
      if (!isModifierPressed) {
        pz.disableMouseWheelZoom();
        setHintVisible(true);
      }
    });

    /* ----------------------------------------------------------------
     *  Wheel handler (only needed when user releases modifier quickly)
     * ----------------------------------------------------------------*/

    const $card = $("#storeCard").css({
      position: "fixed",
      zIndex: 9999,
      pointerEvents: "auto",
      transform: "translate(-50%, 0)",
      display: "none",
    });
    const hideStoreCard = () => $card.stop(true, true).fadeOut(100);

    window.addEventListener("wheel", hideStoreCard, {
      passive: true,
      capture: true,
    });
    window.addEventListener("mousewheel", hideStoreCard, {
      passive: true,
      capture: true,
    }); // fallback

    const $stores = $("#map-wrapper2 svg .store");
    if ($stores.length === 0) return;

    let lastTouchTime = 0;
    let isDragging = false;
    let dragThreshold = 5; // pixels
    let mouseStartPos = { x: 0, y: 0 };
    let touchStartPos = { x: 0, y: 0 };
    const clamp = (v, min, max) => Math.max(min, Math.min(v, max));

    const showCard = (ev, isTouch) => {
      if (ev.touches && ev.touches.length > 1) return;

      const id = ev.currentTarget.id;
      const meta = data[id] || {};
      if (!meta.t1 && !meta.t2 && !meta.t3 && !meta.t4 && !meta.url && !meta.img) return;

      // Debug logging to understand the URL issue
      console.log("Store ID:", id);
      console.log("Store meta:", meta);
      console.log("Store URL:", meta.url);

      $("#cardImg")
        .toggle(!!meta.img)
        .attr("src", meta.img || "");
      $("#cardBtn .btn-label").text(meta.btn || "Details");

      // Check if there's a valid URL (not empty, not just whitespace, not just "#")
      const hasValidUrl =
        meta.url && meta.url.trim() !== "" && meta.url.trim() !== "#";

      console.log("Has valid URL:", hasValidUrl);

      if (hasValidUrl) {
        console.log("Setting URL to:", meta.url);
        $("#cardBtn").attr("href", meta.url).removeClass("d-none").show();
      } else {
        console.log("Hiding button - no valid URL");
        $("#cardBtn").removeAttr("href").addClass("d-none").hide();
      }

      const label = ev.currentTarget.querySelector("text");
      if (!label) return;

      const rect = label.getBoundingClientRect();
      const x = rect.left + rect.width / 2;
      const y = rect.bottom;
      /* -------------------- dimensões e retângulos -------------------- */
      const gap = 12;
      const h = $card.outerHeight(); // altura do card
      const w = $card.outerWidth(); // largura do card
      const wrapperRect = wrapper.getBoundingClientRect(); // ★ NOVO ★

      /* âncora inicial: centro do label */
      let cardLeft = x; // já é coord. de viewport
      let cardTop = y + gap;

      const cardLeftEdge = cardLeft - w / 2;
      const cardRightEdge = cardLeft + w / 2;
      const cardTopEdge = cardTop;
      const cardBottomEdge = cardTop + h;

      /* -------------------- checar overflow no wrapper ---------------- */
      let dx = 0,
        dy = 0;

      if (cardLeftEdge < wrapperRect.left) dx = cardLeftEdge - wrapperRect.left; // saiu à ESQ

      if (cardRightEdge > wrapperRect.right)
        dx = cardRightEdge - wrapperRect.right; // saiu à DIR

      if (cardBottomEdge > wrapperRect.bottom)
        dy = cardBottomEdge - wrapperRect.bottom; // saiu em BAIXO

      if (cardTopEdge < wrapperRect.top) dy = cardTopEdge - wrapperRect.top; // saiu em CIMA

      /* -------------------- panear o mapa se precisar ----------------- */
      if (dx || dy) {
        const zoom = pz.getSizes().realZoom || 1;
        // Converta pixel → unidades SVG dividindo pelo zoom real
        pz.panBy({ x: -dx / zoom, y: -dy / zoom });

        // Ajuste as coords previstas do card (na viewport)
        cardLeft -= dx;
        cardTop -= dy;
      }

      /* -------------------- exibir o card ----------------------------- */
      $card.css({ left: cardLeft, top: cardTop }).fadeIn(150);
    };

    function applyLayout(type = "eat") {
      console.log(`Applying layout: ${type}`);
      $(".mg-btn a.active").removeClass("active");
      $(`.mg-btn a[data-type="${type}"]`).addClass("active");

      // Remove all highlighting classes from all store elements first
      $(".store").removeClass("active-btn related-eat related-shop related-play");

      // Add active-btn class to store elements that match the selected category (primary category)
      const primaryMatches = $(`.store[data-store-category="${type}"]`);
      primaryMatches.addClass("active-btn");
      console.log(`Found ${primaryMatches.length} stores with primary category "${type}"`);

      // Add category-specific class to stores with related categories that match
      let relatedMatches = 0;
      $(".store[data-related-categories]").each(function() {
        const relatedCategories = $(this).attr('data-related-categories');
        if (relatedCategories && relatedCategories.split(',').includes(type)) {
          // Don't add related class if this store already has the primary category
          if (!$(this).hasClass('active-btn')) {
            $(this).addClass(`related-${type}`);
            relatedMatches++;
            console.log(`Store ${$(this).attr('id')} highlighted with related-${type} class via related categories: ${relatedCategories}`);
          }
        }
      });
      console.log(`Found ${relatedMatches} stores with related category "${type}"`);

      config.layout = type;
    }

    function changeSelect(type = "eat") {
      console.log(`Changing select to: ${type}`);
      $(".mg-btn a.active").removeClass("active");
      $(`.mg-btn a[data-type="${type}"]`).addClass("active");

      // Remove all highlighting classes from all store elements first
      $(".store").removeClass("active-btn related-eat related-shop related-play");

      // Add active-btn class to store elements that match the selected category (primary category)
      const primaryMatches = $(`.store[data-store-category="${type}"]`);
      primaryMatches.addClass("active-btn");
      console.log(`Found ${primaryMatches.length} stores with primary category "${type}"`);

      // Add category-specific class to stores with related categories that match
      let relatedMatches = 0;
      $(".store[data-related-categories]").each(function() {
        const relatedCategories = $(this).attr('data-related-categories');
        if (relatedCategories && relatedCategories.split(',').includes(type)) {
          // Don't add related class if this store already has the primary category
          if (!$(this).hasClass('active-btn')) {
            $(this).addClass(`related-${type}`);
            relatedMatches++;
            console.log(`Store ${$(this).attr('id')} highlighted with related-${type} class via related categories: ${relatedCategories}`);
          }
        }
      });
      console.log(`Found ${relatedMatches} stores with related category "${type}"`);

      config.layout = type;
    }

    // Mouse event handlers for drag detection
    $stores.on("mousedown", function (ev) {
      isDragging = false;
      mouseStartPos = { x: ev.clientX, y: ev.clientY };
    });

    $stores.on("mousemove", function (ev) {
      if (mouseStartPos.x === 0 && mouseStartPos.y === 0) return;
      const deltaX = Math.abs(ev.clientX - mouseStartPos.x);
      const deltaY = Math.abs(ev.clientY - mouseStartPos.y);
      if (deltaX > dragThreshold || deltaY > dragThreshold) {
        isDragging = true;
      }
    });

    $stores.on("mouseup mouseleave", function (ev) {
      // Reset mouse position and dragging state
      mouseStartPos = { x: 0, y: 0 };
      // Small delay before resetting isDragging to allow click events to check it
      setTimeout(() => { isDragging = false; }, 10);
    });

    $stores.on("touchstart", function (ev) {
      lastTouchTime = Date.now();
      isDragging = false; // Reset dragging flag on touch start
      // Store initial touch position
      const touch = ev.originalEvent.touches[0];
      touchStartPos = { x: touch.clientX, y: touch.clientY };
      // Don't stop propagation - let Hammer.js handle the touch events
    });

    $stores.on("touchmove", function (ev) {
      if (touchStartPos.x === 0 && touchStartPos.y === 0) return;
      const touch = ev.originalEvent.touches[0];
      const deltaX = Math.abs(touch.clientX - touchStartPos.x);
      const deltaY = Math.abs(touch.clientY - touchStartPos.y);
      if (deltaX > dragThreshold || deltaY > dragThreshold) {
        isDragging = true;
      }
    });

    $stores.on("touchend touchcancel", function (ev) {
      // Reset touch position
      touchStartPos = { x: 0, y: 0 };
      // Small delay to allow pan events to set isDragging flag
      setTimeout(() => {
        if (!isDragging && ev.type === "touchend") {
          showCard(ev, true);
        }
      }, 10);
    });

    $stores.on("click", function (ev) {
      if (Date.now() - lastTouchTime < 400) return; // Avoid double trigger from touch
      if (!isDragging) {
        showCard(ev, false);
      }
    });

    $(document).on("touchstart click", function (e) {
      const $target = $(e.target);
      if (
        !$target.closest(".store").length && // not a store label/pin
        !$target.closest("#storeCard").length // not the popup itself
      ) {
        $card.fadeOut(100);
      }
    });

    function focusOn(id) {
      const el = document.getElementById(id);
      if (!el) return;

      const box = el.getBBox();
      const cx = box.x + box.width / 2;
      const cy = box.y + box.height / 2;
      const view = pz.getSizes();
      const zoom =
        Math.min(view.width / box.width, view.height / box.height) / 4.86;
      pz.zoom(zoom);

      const real = pz.getSizes().realZoom;
      pz.pan({ x: view.width / 2 - cx * real, y: view.height / 2 - cy * real });
    }

    // Mobile and initial store handling is now done in the setTimeout above

    applyLayout(config.layout || "eat");

    $(".mg-btn a").on("click", function (e) {
      e.preventDefault();
      applyLayout($(this).data("type"));
    });

    const select = document.getElementById("magicSelect");
    if (select) {
      changeSelect(select.value);
      select.addEventListener("change", () => changeSelect(select.value));
    }

    $(".select")
      .on("click", ".placeholderz", function () {
        const parent = $(this).closest(".select");
        if (!parent.hasClass("is-open")) {
          parent.addClass("is-open");
          $(".select.is-open").not(parent).removeClass("is-open");
        } else {
          parent.removeClass("is-open");
        }
      })
      .on("click", "ul>li", function () {
        const parent = $(this).closest(".select");
        parent
          .removeClass("is-open")
          .find(".placeholderz")
          .text($(this).text());
        parent.find("input[type=hidden]").val($(this).attr("data-value"));
        parent
          .find(".placeholderz")
          .attr("data-selected", $(this).attr("data-value"));
        changeSelect($(this).attr("data-value"));
      });
  });
})(jQuery);
